import styled from "styled-components";

export const ProfileMenu = styled.div`
  width: 100%;
`;
